import type { NotificationsListQuery } from "@/Modules/Models/Api/ActivityCenter";

import { useActivityCenterStore, type ActivityCenterStore } from "@/Modules/ActivityCenter/Store";
import useChatStore, { type ChatStore } from "@/Modules/Chat/Store";

import ActivityCenterApiConnector from "@/Services/TherapyApi/ActivityCenter";

import { danger } from "@/Utils/Debug";
import { hasValue } from "@/Utils/Objects";
import { isValidString } from "@/Utils/String";

class GetNumberOfNewNotificationsActionHandler {
  constructor(
    private readonly activityCenterStore: ActivityCenterStore = useActivityCenterStore(),
    private readonly chatStore: ChatStore = useChatStore(),
    private readonly activityCenterApiConnector: ActivityCenterApiConnector = new ActivityCenterApiConnector()
  ) {}

  public async handle(user?: string, chatId?: string) {
    this.activityCenterStore.isLoading = true;

    try {
      const notificationsListQuery: NotificationsListQuery = { is_read: false, page_size: 1 };

      if (isValidString(user)) {
        notificationsListQuery.patient_uuid = user;
      }

      const res = await this.activityCenterApiConnector.getNotificationsList(notificationsListQuery);
      const meta = res?.meta;

      if (isValidString(user)) {
        if (isValidString(chatId) && hasValue(this.chatStore.rooms[chatId]) && hasValue(meta?.count)) {
          this.chatStore.rooms[chatId].numberNotifications = meta.count;
        } else {
          const chatIdSearch = (Object.keys(this.chatStore.rooms) as string[]).find(
            (id) => this.chatStore.rooms[id]?.user.id === user
          );

          if (isValidString(chatIdSearch)) {
            this.chatStore.rooms[chatIdSearch]!.numberNotifications = meta.count;
          } else {
            this.activityCenterStore.patientNumberNotifications = meta?.count;
          }
        }
      } else {
        this.activityCenterStore.currentUserNumberNotifications = meta?.count;
      }
    } catch (e) {
      danger(e);
    } finally {
      this.activityCenterStore.isLoading = false;
    }
  }
}

export default GetNumberOfNewNotificationsActionHandler;
